import parsePhoneNumber from 'libphonenumber-js/max';

export function isValidPhonenumber(number) {
    const input = (number || '').trim()
    if (!input) {
        return false
    }

    if (!input.startsWith('+')) {
        return false
    }

    try {
        return parsePhoneNumber(input).isValid()
    } catch {
        return false
    }
}